import { ShieldAlert } from "lucide-react";

export const PREVIEW_MODE =
  (process.env.REACT_APP_PREVIEW_MODE || "").trim() === "1";

export const PREVIEW_NO_PHI_MESSAGE =
  "You’re using the ProsthoAI Preview environment. Please do not enter real patient information. I can show you the patient workflow and explain how this section works, but patient records are disabled during beta testing.";

/**
 * Preview-only no-PHI notice. Renders nothing when PREVIEW_MODE is off, so it
 * is safe to leave in place for Production. The message intentionally mirrors
 * the copy ARIA speaks aloud when a patient-entry command fires in Preview.
 */
export default function PreviewNoPHIBanner({ variant = "full" }) {
  if (!PREVIEW_MODE) return null;

  const isCompact = variant === "compact";
  return (
    <div
      data-testid="preview-nophi-banner"
      role="alert"
      className={
        "flex items-start gap-3 rounded-lg border border-amber-500/40 " +
        "bg-amber-500/10 text-amber-100 " +
        (isCompact ? "px-3 py-2 text-xs " : "px-4 py-3 text-sm ")
      }
    >
      <ShieldAlert
        size={isCompact ? 16 : 18}
        className="shrink-0 mt-0.5 text-amber-300"
        aria-hidden="true"
      />
      <div className="leading-snug">
        <div className="font-semibold text-amber-200">
          Preview environment — Do not enter real patient information or PHI.
        </div>
        <div className="mt-1 text-amber-100/90">
          Patient records are disabled during beta testing. ARIA can demonstrate
          the workflow, but no patient records will be created, saved, or
          displayed in Preview.
        </div>
      </div>
    </div>
  );
}
